function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u9875\\u9762-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u53D1\\u8D77\\u7FA4\\u804A+\\u901A\\u8BAF\\u5F55+\\u7FA4\\u516C\\u544A+\\u62C9\\u4EBA\\u5165\\u7FA4+\\u79FB\\u51FA\\u7FA4\\u804A\\uFF08\\u5F39\\u6846\\uFF09",
  transform: "translate(-979.000000, -183.000000)",
  fill: "#CCCCCC",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "\\u7F16\\u7EC4-11",
  transform: "translate(420.000000, 40.000000)"
}, React.createElement("g", {
  id: "\\u7F16\\u7EC4-14",
  transform: "translate(559.000000, 143.000000)"
}, React.createElement("polygon", {
  id: "\\u76F4\\u7EBF-6",
  points: "2 8.89759395 3.08390629 10 8 5 3.08390629 0 2 1.10240605 5.83218743 5"
})))));

var SvgRightArrow = function SvgRightArrow(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "10px",
    height: "10px",
    viewBox: "0 0 10 10",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRightArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rightArrow.2fc57826.svg";
export { ForwardRef as ReactComponent };